import * as React from "react"
const SvgAttachment = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M18 15.893q0 2.6-1.825 4.425-1.826 1.825-4.425 1.825-2.6 0-4.425-1.825Q5.5 18.492 5.5 15.893v-9.25q0-1.875 1.313-3.188C8.126 2.142 8.75 2.143 10 2.143q1.875 0 3.188 1.312Q14.5 4.768 14.5 6.643v8.75q0 1.15-.8 1.95t-1.95.8a2.65 2.65 0 0 1-1.95-.8 2.65 2.65 0 0 1-.8-1.95v-8.25q0-.425.287-.713A.97.97 0 0 1 10 6.143q.424 0 .713.287.287.288.287.713v8.25a.73.73 0 0 0 .75.75.73.73 0 0 0 .75-.75v-8.75q-.025-1.05-.738-1.775-.712-.725-1.762-.725c-1.05 0-1.292.242-1.775.725Q7.5 5.592 7.5 6.643v9.25q-.025 1.775 1.225 3.012t3.025 1.238q1.75 0 2.975-1.238T16 15.893v-8.75q0-.425.288-.713A.97.97 0 0 1 17 6.143a.97.97 0 0 1 .712.287q.288.288.288.713z" />
  </svg>
)
export default SvgAttachment
